import {
  createSlice,
  createEntityAdapter,
  createSelector,
  // createAsyncThunk,
  // PayloadAction,
  // createAction,
} from "@reduxjs/toolkit";
import { Notification } from "admin/types/notification";
import { isFulfilledAction, isRejectedAction } from "../utils/sliceUtil";
import { RootState } from "../store";

const key = "notification";
const adapter = createEntityAdapter<Notification.Notification>();

const initialStateValues: Notification.NotificationState = {
  notifications: [],
};

const initialState = adapter.getInitialState(initialStateValues);

const uid = () => {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
};

const messageTexts = {
  "adminUser/postAdminUser/fulfilled": "notification.postAdminUser",
  "adminUser/postAdminUser/rejected": "",
  "adminUser/putAdminUser/fulfilled": "notification.putAdminUser",
  "adminUser/putAdminUser/rejected": "",
  "adminUser/resendAdminUserInvitation/fulfilled":
    "notification.resendAdminUserInvitation",
  "adminUser/resendAdminUserInvitation/rejected": "",
  "company/postCompany/fulfilled": "notification.postCompany",
  "company/postCompany/rejected": "",
  "company/putCompany/fulfilled": "notification.putCompany",
  "company/putCompany/rejected": "",
  "company/postUserImportSetting/fulfilled":
    "notification.postUserImportSetting",
  "company/postUserImportSetting/rejected": "",
  "company/postCompanySystemUsageFees/fulfilled":
    "notification.postCompanySystemUsageFees",
  "company/postCompanySystemUsageFees/rejected": "",
  "company/postCompanyCreditCardFees/fulfilled":
    "notification.postCompanyCreditCardFees",
  "company/postCompanyCreditCardFees/rejected": "",
  "companyAdminUser/postCompanyAdminUser/fulfilled":
    "notification.postCompanyAdminUser",
  "companyAdminUser/postCompanyAdminUser/rejected": "",
  "companyAdminUser/putCompanyAdminUser/fulfilled":
    "notification.putCompanyAdminUser",
  "companyAdminUser/putCompanyAdminUser/rejected": "",
  "companyAdminUser/resendCompanyAdminUserInvitation/fulfilled":
    "notification.resendAdminUserInvitation",
  "hotel/postHotel/fulfilled": "notification.postHotel",
  "hotel/postHotel/rejected": "",
  "hotel/putHotel/fulfilled": "notification.putHotel",
  "hotel/putHotel/rejected": "",
  "hotelCancelPolicy/postHotelCancelPolicyRelation/fulfilled":
    "notification.postHotelCancelPolicy",
  "hotelCancelPolicy/postHotelCancelPolicyRelation/rejected": "",
  "hotelCancelPolicy/putHotelCancelPolicyRelation/fulfilled":
    "notification.putHotelCancelPolicy",
  "hotelCancelPolicy/putHotelCancelPolicyRelation/rejected": "",
  "hotelCancelPolicy/deleteHotelCancelPolicyRelation/fulfilled":
    "notification.deleteHotelCancelPolicy",
  "hotelCancelPolicy/deleteHotelCancelPolicyRelation/rejected": "",
  "hotelRoom/postHotelRoom/fulfilled": "notification.postHotelRoom",
  "hotelRoom/postHotelRoom/rejected": "",
  "hotelRoom/putHotelRoom/fulfilled": "notification.putHotelRoom",
  "hotelRoom/putHotelRoom/rejected": "",
  "hotelRoom/putHotelRoomOrder/rejected": "",
  "hotelRoom/deleteHotelRoom/fulfilled": "notification.deleteHotelRoom",
  "hotelRoom/deleteHotelRoom/rejected": "",
  "hotelRoom/deleteHotelRoomImage/fulfilled":
    "notification.deleteHotelRoomImage",
  "hotelRoom/deleteHotelRoomImage/rejected": "",
  "hotelRoom/putHotelRoomImageOrder/fulfilled":
    "notification.putHotelRoomImageOrder",
  "hotelRoom/putHotelRoomImageOrder/rejected": "",
  "hotelRoomChildrenSetting/postHotelRoomChildrenSettings/fulfilled":
    "notification.postHotelChildrenSetting",
  "hotelRoomChildrenSetting/postHotelRoomChildrenSettings/rejected": "",
  "hotelPlan/postHotelPlan/fulfilled": "notification.postHotelPlan",
  "hotelPlan/postHotelPlan/rejected": "",
  "hotelPlan/putHotelPlan/fulfilled": "notification.putHotelPlan",
  "hotelPlan/putHotelPlan/rejected": "",
  "hotelPlan/putHotelPlanOrder/rejected": "",
  "hotelPlan/deleteHotelPlan/fulfilled": "notification.deleteHotelPlan",
  "hotelPlan/deleteHotelPlan/rejected": "",
  "hotelPlan/deleteHotelPlanImage/fulfilled":
    "notification.deleteHotelPlanImage",
  "hotelPlan/deleteHotelPlanImage/rejected": "",
  "hotelPlan/putHotelPlanImageOrder/fulfilled":
    "notification.putHotelPlanImageOrder",
  "hotelPlan/putHotelPlanImageOrder/rejected": "",
  "autoTranslation/fetchAutoTranslation/rejected": "",
  "hotelChildrenSetting/postHotelChildrenSettings/fulfilled":
    "notification.postHotelChildrenSetting",
  "hotelChildrenSetting/postHotelChildrenSettings/rejected": "",
  "hotelPlanChildrenSetting/postHotelPlanChildrenSettings/fulfilled":
    "notification.postHotelChildrenSetting",
  "hotelPlanChildrenSetting/postHotelPlanChildrenSettings/rejected": "",
  "hotelPlanCancelPolicy/postHotelPlanCancelPolicy/fulfilled":
    "notification.postHotelCancelPolicy",
  "hotelPlanCancelPolicy/postHotelPlanCancelPolicy/rejected": "",
  "hotelPlanCancelPolicy/putHotelPlanCancelPolicy/fulfilled":
    "notification.putHotelCancelPolicy",
  "hotelPlanCancelPolicy/putHotelPlanCancelPolicy/rejected": "",
  "hotelPlanCancelPolicy/deleteHotelPlanCancelPolicy/fulfilled":
    "notification.deleteHotelCancelPolicy",
  "hotelPlanCancelPolicy/deleteHotelCancelPolicy/rejected": "",
  "hotelQuestion/postHotelQuestion/fulfilled": "notification.postHotelQuestion",
  "hotelQuestion/postHotelQuestion/rejected": "",
  "hotelQuestion/putHotelQuestion/fulfilled": "notification.putHotelQuestion",
  "hotelQuestion/putHotelQuestion/rejected": "",
  "hotelQuestion/putHotelQuestionOrder/rejected": "",
  "hotelQuestion/deleteHotelQuestion/fulfilled":
    "notification.deleteHotelQuestion",
  "hotelQuestion/deleteHotelQuestion/rejected": "",
  "hotelOption/postHotelOption/fulfilled": "notification.postHotelOption",
  "hotelOption/postHotelOption/rejected": "",
  "hotelOption/putHotelOption/fulfilled": "notification.putHotelOption",
  "hotelOption/putHotelOption/rejected": "",
  "hotelOption/putHotelOptionOrder/rejected": "",
  "hotelOption/deleteHotelOptionImage/fulfilled":
    "notification.deleteHotelOptionImage",
  "hotelOption/deleteHotelOptionImage/rejected": "",
  "hotelFilter/postHotelFilter/fulfilled": "notification.postHotelFilter",
  "hotelFilter/postHotelFilter/rejected": "",
  "hotelFilter/deleteHotelFilter/fulfilled": "notification.deleteHotelFilter",
  "hotelFilter/deleteHotelFilter/rejected": "",
  "hotel/postHotelMailSettings/fulfilled": "notification.postHotelMailSettings",
  "hotel/postHotelMailSettings/rejected": "",
  "hotel/importHotel/fulfilled": "notification.importHotel",
  "hotel/importHotel/rejected": "",
  "hotel/postHotelChannelManager/fulfilled":
    "notification.postHotelChannelManager",
  "hotel/postHotelChannelManager/rejected": "",
  "hotel/postCheckInSettings/fulfilled": "notification.postCheckInSettings",
  "hotel/postCheckInSettings/rejected": "",
  "hotelMail/postHotelMail/fulfilled": "notification.postHotelMail",
  "hotelMail/postHotelMail/rejected": "",
  "hotelMail/putHotelMail/fulfilled": "notification.putHotelMail",
  "hotelMail/putHotelMail/rejected": "",
  "hotelMail/deleteHotelMail/fulfilled": "notification.deleteHotelMail",
  "hotelMail/deleteHotelMail/rejected": "",
  "hotelPromotion/postHotelPromotion/fulfilled":
    "notification.postHotelPromotion",
  "hotelPromotion/postHotelPromotion/rejected": "",
  "hotelPromotion/putHotelPromotion/fulfilled":
    "notification.putHotelPromotion",
  "hotelPromotion/putHotelPromotion/rejected": "",
  "hotelInventory/putHotelInventory/rejected": "",
  "hotelInventory/updateHotelInventories/rejected": "",
  "hotelScript/putHotelScript/fulfilled": "notification.putHotelScript",
  "hotelScript/putHotelScript/rejected": "",
  "hotelCheckIn/postHotelCheckIn/fulfilled": "notification.postHotelCheckIn",
  "hotelCheckIn/postHotelCheckIn/rejected": "",
  "hotelCheckIn/putHotelCheckIn/fulfilled": "notification.putHotelCheckIn",
  "hotelCheckIn/putHotelCheckIn/rejected": "",
  "hotelCheckInQuestion/postHotelCheckInQuestion/fulfilled":
    "notification.postHotelCheckInQuestion",
  "hotelCheckInQuestion/postHotelCheckInQuestion/rejected": "",
  "hotelCheckInQuestion/putHotelCheckInQuestion/fulfilled":
    "notification.putHotelCheckInQuestion",
  "hotelCheckInQuestion/putHotelCheckInQuestion/rejected": "",
  "hotelCheckInQuestion/deleteHotelCheckInQuestion/fulfilled":
    "notification.deleteHotelCheckInQuestion",
  "hotelCheckInQuestion/deleteHotelCheckInQuestion/rejected": "",
  "hotelPushMessageGroup/postPushMessageGroup/fulfilled":
    "notification.postPushMessageGroup",
  "hotelPushMessageGroup/postPushMessageGroup/rejected": "",
  "hotelPushMessageGroup/putPushMessageGroup/fulfilled":
    "notification.putPushMessageGroup",
  "hotelPushMessageGroup/putPushMessageGroup/rejected": "",
  "hotelPushMessageGroup/sendPushMessageGroup/fulfilled":
    "notification.sendPushMessageGroup",
  "hotelPushMessageGroup/sendPushMessageGroup/rejected": "",
  "hotelPushMessageGroup/fetchRecipientCount/rejected": "",
  "hotelSpecifiedStaysOnlyPeriod/postHotelSpecifiedStaysOnlyPeriod/fulfilled":
    "notification.postHotelSpecifiedStaysOnlyPeriod",
  "hotelSpecifiedStaysOnlyPeriod/postHotelSpecifiedStaysOnlyPeriod/rejected":
    "",
  "hotelSpecifiedStaysOnlyPeriod/putHotelSpecifiedStaysOnlyPeriod/fulfilled":
    "notification.putHotelSpecifiedStaysOnlyPeriod",
  "hotelSpecifiedStaysOnlyPeriod/putHotelSpecifiedStaysOnlyPeriod/rejected": "",
  "hotelSpecifiedStaysOnlyPeriod/deleteHotelSpecifiedStaysOnlyPeriod/fulfilled":
    "notification.deleteHotelSpecifiedStaysOnlyPeriod",
  "hotelSpecifiedStaysOnlyPeriod/deleteHotelSpecifiedStaysOnlyPeriod/rejected":
    "",
  "booking/resendBookingMail/fulfilled": "notification.resendBookingMail",
  "booking/resendBookingMail/rejected": "",
  "booking/sendCreditCardChangeMail/fulfilled":
    "notification.sendCreditCardChangeMail",
  "booking/sendCreditCardChangeMail/rejected": "",
  "booking/confirmBookingRoomGuests/rejected": "",
  "booking/cancelBookingRoomGuests/fulfilled":
    "notification.cancelBookingRoomGuests",
  "booking/cancelBookingRoomGuests/rejected": "",
  "booking/putBooking/fulfilled": "notification.putBooking",
  "booking/putBooking/rejected": "",
  "booking/cancelBooking/rejected": "",
  "booking/cancelBookingRoom/rejected": "",
  "booking/cancelBookingOption/rejected": "",
  "promotion/postPromotion/fulfilled": "notification.postPromotion",
  "promotion/postPromotion/rejected": "",
  "promotion/putPromotion/fulfilled": "notification.putPromotion",
  "promotion/putPromotion/rejected": "",
  "user/putUser/fulfilled": "notification.putUser",
  "user/putUser/rejected": "",
  "user/postProfileCsvImport/fulfilled": "notification.postProfileCsvImport",
  "user/postProfileCsvImport/rejected": "",
  "newsletter/postNewsletter/fulfilled": "notification.postNewsletter",
  "newsletter/postNewsletter/rejected": "",
  "newsletter/putNewsletter/fulfilled": "notification.putNewsletter",
  "newsletter/putNewsletter/rejected": "",
  "newsletter/sendNewsletter/fulfilled": "notification.sendNewsletter",
  "newsletter/sendNewsletter/rejected": "",
  "newsletter/sendTestNewsletter/fulfilled": "notification.sendTestNewsletter",
  "newsletter/sendTestNewsletter/rejected": "",
  "newsletter/fetchRecipientCount/rejected": "",
};

const isNotificationActionType = (type) => {
  const keys = Object.keys(messageTexts);
  return keys.includes(type);
};

/** slice * */
export const notificationSlice = createSlice({
  name: key,
  initialState,
  reducers: {
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        (notification) => notification.id !== action.payload,
      );
    },
    clearNotifications: (state) => {
      state.notifications = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(isRejectedAction(".+"), (state, action: any) => {
        if (isNotificationActionType(action.type)) {
          let errorMessages;
          if (action.payload?.messages) {
            errorMessages = action.payload?.messages;
          }
          if (errorMessages && errorMessages.length > 0) {
            const notification: Notification.Notification = {
              id: uid(),
              type: "error",
              message: errorMessages.join("\n"),
            };
            state.notifications = [notification].concat(state.notifications);
          }
        }
      })
      .addMatcher(isFulfilledAction(".+"), (state, action) => {
        if (isNotificationActionType(action.type)) {
          const notification: Notification.Notification = {
            id: uid(),
            type: "success",
            message: messageTexts[action.type],
          };
          state.notifications = [notification].concat(state.notifications);
        }
      });
  },
});

/** selector * */
const stateSelector = (state: RootState) => state[key];

export const notificationSelector = createSelector(
  stateSelector,
  (state) => state.notifications,
);

// action export
export const { removeNotification, clearNotifications } =
  notificationSlice.actions;
